module.exports = __webpack_public_path__ + "static/media/projectReportEmpty.0cbd71ab.svg";